import Modal from "../../../components/Modal/Modal"
import styles from './GivewayHistoryModal.module.css'
import { ReactComponent as StarListIcon } from '../../../assets/listStar.svg'
import GivewayListItem from "../GivewayListItem/GivewayListItem"

const GivewayHistoryModal = () => {
    return (
        <Modal>
            <div className={styles.container}>
                <div className={styles.iconContainer}><StarListIcon /></div>
                <div className={styles.textContainer}>
                    <div className={styles.textTitle}>История розыгрышей</div>
                    <div className={styles.textSubtitle}>
                        Один билет равняется одному шансу на выигрыш от общего количества
                    </div>
                </div>
                <div className={styles.listContainer}>
                    <GivewayListItem type='Премиум' icon={'https://telegram.org/file/400780400440/3/tT1re8_uckY.28682.png/004617f1849e49bc39'}
                        name={'mega spin'} progress={110} allProgress={10000} btnText="Победители" />
                    <GivewayListItem type='Премиум' icon={'https://telegram.org/file/400780400440/3/tT1re8_uckY.28682.png/004617f1849e49bc39'}
                        name={'mega spin'} progress={110} allProgress={10000} btnText="Победители" />
                    <GivewayListItem type='Премиум' icon={'https://telegram.org/file/400780400440/3/tT1re8_uckY.28682.png/004617f1849e49bc39'}
                        name={'mega spin'} progress={110} allProgress={10000} btnText="Победители" />
                    <GivewayListItem type='Премиум' icon={'https://telegram.org/file/400780400440/3/tT1re8_uckY.28682.png/004617f1849e49bc39'}
                        name={'mega spin'} progress={110} allProgress={10000} btnText="Победители" />
                </div>
            </div>
        </Modal>
    )
}

export default GivewayHistoryModal